import { faPause, faPlay } from '@fortawesome/pro-solid-svg-icons';
import { useMediaRemote, useMediaState } from '@vidstack/react';
import { useCallback } from 'react';
import { PlayerControlButton } from './base-button';
import { useVideoPlayerContext } from '../../player-context';

export const PlayButton = () => {
  const { playerRef } = useVideoPlayerContext();
  const canPlay = useMediaState('canPlay', playerRef!);
  const isPlaying = useMediaState('playing', playerRef!);
  const remote = useMediaRemote(playerRef);
  const handlePlay = useCallback(() => {
    if (canPlay) {
      remote.play();
    }
  }, [canPlay, remote]);
  const handlePause = useCallback(() => {
    if (canPlay) {
      remote.pause();
    }
  }, [canPlay, remote]);
  const handleClick = useCallback(() => {
    if (isPlaying) {
      handlePause();
    } else {
      handlePlay();
    }
  }, [isPlaying, handlePause, handlePlay]);

  return (
    <PlayerControlButton
      icon={isPlaying ? faPause : faPlay}
      onClick={handleClick}
    />
  );
};
